import "./OnboardingScreen.scss";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import {ImageConfig, Misc} from "../../../constants";
import React, {useState} from "react";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import IconButtonComponent from "../../../shared/components/icon-button/IconButtonComponent";
import {Link, useLocation} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import AttendanceAndCancellationPolicyComponent
    from "../../transaction/attendance-and-cancellation-policy/AttendanceAndCancellationPolicyComponent";


interface OnboardingScreenProps {

}

const OnboardingScreen = (props: OnboardingScreenProps) => {

    const [isPrivacyPolicyModalOpen, setIsPrivacyPolicyModalOpen] = useState<boolean>(false);
    const [isAttendancePolicyModalOpen, setIsAttendancePolicyModalOpen] = useState<boolean>(false);
    const location = useLocation();
    // const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const appointmentId = params.get("appointmentId");
    const {systemSettingsDetails} = useSelector((state: IRootReducerState) => state.user);


    // const handleNavigation = useCallback(() => {
    //     if (appointmentId) {
    //         console.log('appointmentId==>', appointmentId);
    //         navigate(CommonService._routeConfig.ClientRegistration() +'?appointmentId=' + appointmentId);
    //     } else {
    //         navigate(CommonService._routeConfig.ClientRegistration());
    //     }
    // }, [appointmentId, navigate]);


    return (
        <div className={'onboarding-screen-wrapper'}>
            <div className="logo-wrapper">
                <img src={ImageConfig.Logo} alt={Misc.APP_NAME}/>
            </div>
            <div className="on-boarding-screen">
                <div className={'on-boarding-screen-header-wrapper'}>
                    <div className="on-boarding-screen__header ">
                        <img src={ImageConfig.KinergyLogo2} alt="logo"/>
                    </div>
                </div>
                <div className="on-boarding-screen__body">
                    <div className="on-boarding-screen__body__row on-boarding-screen__body__title">
                        Welcome to the Client Portal Registration!
                    </div>
                    <div className="on-boarding-screen__body__row on-boarding-screen__body__description">
                        To simplify your check-in process, we will guide you through the information we need from you to
                        create your account.
                    </div>
                    <div className="on-boarding-screen__body__row">
                        Enter and submit the requested information in each section. While most fields are optional,
                        those marked with an asterisk (*) are mandatory. Please refrain from using the back or forward
                        buttons on your browser, as this may cause errors by undoing or redoing your recent actions.
                    </div>
                    <div className="on-boarding-screen__body__row">
                        Rest assured, the information you provide is encrypted for your security, kept confidential, and
                        transmitted safely to our facility.
                    </div>
                    <div className="on-boarding-screen__body__row">
                        If you have any questions or concerns, feel free to contact us at any time.
                    </div>
                    <div className="on-boarding-screen__body__row">
                        <ImageConfig.CallIcon
                            color={"#83909D"}/>&nbsp;&nbsp;{CommonService.formatPhoneNumber(systemSettingsDetails?.other_settings?.admin_phone)}
                    </div>
                    <span className={'font-size-16'}>Please click the following link to view our
                    <span className={'notice-and-attendance-link'} onClick={() => setIsPrivacyPolicyModalOpen(true)}>  Notice of Privacy Practices</span>
                        &nbsp;and <span className={'notice-and-attendance-link'}
                                        onClick={() => setIsAttendancePolicyModalOpen(true)}> Attendance/Cancellation Policy.</span>
                </span>
                    {/*   </span></span>
*/}

                    <div className="on-boarding-screen__footer">
                        {appointmentId && <Link
                            to={CommonService._routeConfig.ClientRegistration() + '?appointmentId=' + appointmentId}>
                            <ButtonComponent
                                id={'next_btn'}
                                fullWidth={true}
                                suffixIcon={<ImageConfig.ArrowRightCircle/>}
                            >
                                Next
                            </ButtonComponent>
                        </Link>}
                        {appointmentId === null &&
                            <Link
                                to={CommonService._routeConfig.ClientRegistration()}>
                                <ButtonComponent
                                    id={'next_btn'}
                                    fullWidth={true}
                                    suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                >
                                    Next
                                </ButtonComponent>
                            </Link>
                        }
                    </div>
                </div>
                <ModalComponent isOpen={isPrivacyPolicyModalOpen}
                                className="privacy-policy-modal"
                                onClose={() => setIsPrivacyPolicyModalOpen(false)}>
                    <div className="privacy-policy-modal__content">
                        <div className="privacy-policy-modal__content_left">
                            <div className="privacy-policy-modal__content_icon">
                                <ImageConfig.PrivacyPolicyIcon/>
                            </div>
                            <div className="privacy-policy-modal__content_title">
                                Notice of Privacy<br/>
                                Practices
                            </div>
                        </div>
                        <div className="privacy-policy-modal__content_right onboarding-privacy-policy-modal">
                            <div className="privacy-policy-modal__content_right__header">
                                <IconButtonComponent id={'close_btn'} onClick={
                                    () => setIsPrivacyPolicyModalOpen(false)
                                }>
                                    <ImageConfig.CloseIcon/>
                                </IconButtonComponent>
                            </div>
                            <div className="privacy-policy-modal__content_right__block">
                                <div className="privacy-policy-modal__content_right__block__title">
                                    Our Notice of Privacy Practices
                                </div>
                                <div className="privacy-policy-modal__content_right__block__content">
                                    At <b>Kinergy Sports Medicine and Performance,</b> we respect and are committed to
                                    protecting your privacy and ensuring that your personal health information is
                                    handled with the utmost care and confidentiality. As part of this commitment, the
                                    collection, use, and disclosure of certain personal and health information about you
                                    are governed by the Health Insurance Portability and Accountability Act of 1996
                                    (HIPAA) and applicable state law. Any information you provide to us that qualifies
                                    as Protected Health Information (PHI), as defined by HIPAA, will be handled
                                    according to HIPAA guidelines and relevant state regulations.

                                    <br/> <br/>
                                    PHI refers to individually identifiable health information related to your past,
                                    present, or future physical or mental health conditions. This <b>Notice of Privacy
                                    Practices</b> explains how your PHI may be used and disclosed, as well as how you
                                    can
                                    access and control this information.
                                </div>
                                <div className="health-info">
                                    <div className="health-title mrg-bottom-20">1. Uses and Disclosures of Health
                                        Information
                                    </div>
                                    <div className="health-content mrg-bottom-20">
                                        We may use and disclose your health information for the following purposes:
                                    </div>

                                    <div className="health-list mrg-left-20">
                                        <div className="health-item">
                                            <span className="bold">Treatment:</span> We may use your health information
                                            to provide, coordinate, or manage any of your cases. This may involve
                                            sharing your information with other healthcare providers, such as physicians
                                            or specialists, involved in your care.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Payment:</span> We may use or disclose your
                                            information to bill and collect payment for the services provided to you.
                                            This may include sending your health information to insurance companies or
                                            other third-party payers.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Healthcare Operations:</span> We may use your
                                            information for administrative purposes, such as quality control,
                                            improvement of services, and training of staff.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Appointment Reminders:</span> We may use your health
                                            information to contact you for appointment reminders or follow-up care.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Legal Requirements:</span> We may disclose your
                                            health information when required by law, such as in response to subpoenas,
                                            court orders, or government investigations.
                                        </div>
                                    </div>
                                </div>
                                <div className="health-info">
                                    <div className="health-title mrg-bottom-20 mrg-top-20">2. Your Rights Regarding
                                        Health
                                        Information
                                    </div>
                                    <div className="health-content mrg-bottom-20">
                                        You have the following rights concerning your health information:
                                    </div>

                                    <div className="health-list mrg-left-20">
                                        <div className="health-item">
                                            <span className="bold">Right to Access:</span> You have the right to
                                            request and inspect copies of your medical records. We may charge a fee for
                                            the cost of copying and mailing.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Right to Correct Information:</span> If you believe
                                            any information in your medical record is incorrect or incomplete, you have
                                            the right to request that it be corrected.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Right to Request Restrictions:</span> You have the
                                            right to request restrictions on how your health information is used or
                                            disclosed. While we are not required to agree to all requests, we will
                                            consider them.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Right to Confidential Communications:</span> You have
                                            the right to request that we communicate with you about your health
                                            information in a certain way or at a certain location (e.g., by phone
                                            instead of mail).
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Right to an Accounting of Disclosures:</span> You
                                            have the right to request a list of disclosures of your health information
                                            made by us for purposes other than treatment, payment, and healthcare
                                            operations.
                                        </div>

                                        <div className="health-item">
                                            <span className="bold">Right to a Copy of This Notice:</span> You may
                                            request a copy of this Notice of Privacy Practices at any time, even if you
                                            have already received one.
                                        </div>
                                    </div>
                                </div>

                                <div className="health-info">
                                    <div className="health-title mrg-bottom-20 mrg-top-20">3. How We Protect Your
                                        Information
                                    </div>
                                    <div className="health-content mrg-bottom-20">
                                        We are committed to securing your personal health information. We use a variety
                                        of security measures, such as encryption and secure access protocols, to protect
                                        your information from unauthorized access or disclosure. We also limit access to
                                        your health information to those employees and partners who need it to perform
                                        their job duties.
                                    </div>
                                </div>
                                <div className="health-info">
                                    <div className="health-title mrg-bottom-20 mrg-top-20">4. Changes to This Notice
                                    </div>
                                    <div className="health-content mrg-bottom-20">
                                        We may change the terms of this Notice at any time. Any changes will be
                                        effective immediately upon updating this notice in our clinic and on our
                                        website. You will also receive a copy of the revised notice through your Client
                                        Portal.
                                    </div>
                                </div>
                                <div className="health-info">
                                    <div className="health-title mrg-bottom-20 mrg-top-20">5. Filing a Complaint
                                    </div>
                                    <div className="health-content mrg-bottom-20">
                                        If you believe that your privacy rights have been violated, you may file a
                                        complaint with us or with the U.S. Department of Health and Human Services. We
                                        will not retaliate against you for filing a complaint.
                                    </div>
                                    <div className="health-content mrg-bottom-20">
                                        To file a complaint or if you have questions about this Notice, please contact:
                                    </div>
                                    <div className="health-content">
                                        <div className={'bold'}>Terrill Lobo</div>
                                        <div className="health-content">
                                            Owner, Kinergy Sports Medicine and Performance
                                        </div>
                                        <div className="health-content">
                                            Phone: {CommonService.formatPhoneNumber(systemSettingsDetails?.other_settings?.admin_phone)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalComponent>

                <ModalComponent isOpen={isAttendancePolicyModalOpen}
                                onClose={() => setIsAttendancePolicyModalOpen(false)}>
                    <AttendanceAndCancellationPolicyComponent
                        setIsAttendanceModalOpen={setIsAttendancePolicyModalOpen}/>
                    {/*<div className="privacy-policy-modal__content">*/}
                    {/*    <div className="privacy-policy-modal__content_left">*/}
                    {/*        <div className="privacy-policy-modal__content_icon">*/}
                    {/*            <ImageConfig.AttendancePolicyIcon/>*/}
                    {/*        </div>*/}
                    {/*        <div className="privacy-policy-modal__content_title">*/}
                    {/*            Attendance/Cancellation*/}
                    {/*            <br/>Policy*/}

                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="privacy-policy-modal__content_right">*/}
                    {/*        <div className="privacy-policy-modal__content_right__header">*/}
                    {/*            <IconButtonComponent id={'close_btn'} onClick={*/}
                    {/*                () => setIsAttendancePolicyModalOpen(false)*/}
                    {/*            }>*/}
                    {/*                <ImageConfig.CloseIcon/>*/}
                    {/*            </IconButtonComponent>*/}
                    {/*        </div>*/}
                    {/*        <div className="privacy-policy-modal__content_right__block">*/}
                    {/*            <div className="privacy-policy-modal__content_right__block__title">*/}
                    {/*                Our Attendance/Cancellation Policy*/}
                    {/*            </div>*/}
                    {/*            <div className="privacy-policy-modal__content_right__block__content">*/}
                    {/*                Kinergy Sports Medicine and Performance strives to provide all our clients with the*/}
                    {/*                highest quality of service at all times.*/}
                    {/*                We aim to provide you with appointments that are accommodating to your schedule, and*/}
                    {/*                we*/}
                    {/*                expect you to be on time*/}
                    {/*                for your scheduled appointments.*/}

                    {/*                <br/> <br/>*/}

                    {/*                <div className={'attendance-policy-header'}> Our attendance policy is as follows:*/}
                    {/*                </div>*/}

                    {/*                <ul className={'pdd-left-20'}>*/}
                    {/*                    <li className={'pdd-bottom-20'}> If you are more than thirty (30) minutes late*/}
                    {/*                        for*/}
                    {/*                        an appointment without advanced notification, the appointment*/}
                    {/*                        will be canceled, and the full appointment fee will be charged.*/}

                    {/*                    </li>*/}

                    {/*                    <li className={'pdd-bottom-20'}>To make sure we do not run behind on our*/}
                    {/*                        schedule,*/}
                    {/*                        in the event you arrive late for an appointment, you will*/}
                    {/*                        not be granted additional appointment time for the time you have missed.*/}
                    {/*                        Additionally, the full appointment*/}
                    {/*                        fee will be charged.*/}
                    {/*                    </li>*/}

                    {/*                    <li className={'pdd-bottom-20'}> A scheduled appointment <b>MUST BE CANCELED AT*/}
                    {/*                        LEAST TWENTY-FOUR (24) HOURS IN ADVANCE,</b> or the full*/}
                    {/*                        appointment fee will be charged.*/}

                    {/*                    </li>*/}
                    {/*                    <li className={'pdd-bottom-20'}> If you cancel an appointment less than*/}
                    {/*                        twenty-four*/}
                    {/*                        (24) hours in advance or do not show for an appointment,*/}
                    {/*                        a full appointment fee will be charged.*/}

                    {/*                    </li>*/}
                    {/*                    <li className={'pdd-bottom-20'}> Failure to be on time or to show up for an*/}
                    {/*                        appointment without providing advanced notification will result in*/}
                    {/*                        the full appointment fee being charged for that appointment. Furthermore,*/}
                    {/*                        three*/}
                    {/*                        (3) consecutive absences*/}
                    {/*                        without advanced notification will result in the cancellation of all your*/}
                    {/*                        remaining scheduled appointments.*/}
                    {/*                    </li>*/}
                    {/*                    <li className={'pdd-bottom-20'}>*/}
                    {/*                        All cancellations and absences will be documented in your client record. If*/}
                    {/*                        appropriate, we will report all*/}
                    {/*                        absences to your physician and insurance company or third party payor.*/}
                    {/*                    </li>*/}
                    {/*                    <li className={'pdd-bottom-20'}>*/}
                    {/*                        The client is responsible for all fees associated with late, no show or*/}
                    {/*                        cancellations.*/}
                    {/*                    </li>*/}
                    {/*                    <li className={'pdd-bottom-20'}>*/}
                    {/*                        Kinergy withholds the right, at any time, to deny service to clients who*/}
                    {/*                        repeatedly do not abide by the above*/}
                    {/*                        terms.*/}
                    {/*                    </li>*/}
                    {/*                </ul>*/}
                    {/*                <div>I acknowledge that I have read and agree to the company policy as written*/}
                    {/*                    above.*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </ModalComponent>

            </div>
        </div>
    );

};

export default OnboardingScreen;
